import { contactData } from '@/mocks/home';

export default function ContactSection() {
  // Using static contact display as specified - no real form submission
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-10">
          {contactData.title}
        </h2>
        <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
          {contactData.description}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-8">
          <div className="flex items-center gap-2 text-sm text-foreground-700">
            <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
              <i className="ri-mail-line text-lg"></i>
            </span>
            <span>{contactData.email}</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-foreground-700">
            <span className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
              <i className="ri-wechat-line text-lg"></i>
            </span>
            <span>{contactData.wechat}</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-foreground-700">
            <span className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600">
              <i className="ri-qq-line text-lg"></i>
            </span>
            <span>{contactData.qq}</span>
          </div>
        </div>
      </div>
    </section>
  );
}